import {fetchBody, URL_MENU_USERMENU, URL_MENU_REALMENU, URL_PAGE_REALLIST, URL_PAGE_USERLIST, URL_MENU_ADDHEADER, URL_MENU_ADDTITLE, URL_MENU_ADDITEM, URL_PAGE_ADD} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";


export const getUserMenu = ({success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_MENU_USERMENU, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        //console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
  return;
}

export const getRealMenu = ({success, failure}) => {
  console.log("getRealMenu")
    var token = getToken()
    if(token === ""){
      toLogout(false);
    }else{
      //console.log(fetchBody({token}))
      cleanFetch({
        body: fetchBody({token}), 
        url: URL_MENU_REALMENU, 
        success:(jsonDate)=>{
          //var menu = analysisMenu(jsonDate.menus);
          //var menu = analysisMenu(jsonDate.menus);
          //console.log(jsonDate)
          success(jsonDate, jsonDate.menus)
        }, 
        failure
      })
    }
  return;
}

const analysisMenu = (results) =>{
  console.log("analysisMenu")
  var all = [];
  results.forEach(result => {
    var level0Empty = all.filter(function(item, index, array){
      return item.menuId === result.menuId1;
    });
    //陣列中沒有第一層資料時
    if(level0Empty.length === 0){
      var level0 = {menuId: result.menuId1, menuName:result.menuName1, sequence:result.sequence1, titles:[
      ]};
      if(result.menuId2 !== null){
        level0.titles = [
          {menuId: result.menuId2, menuName:result.menuName2, icon: result.icon2, sequence: result.sequence2, items:[]}
        ]
        if(result.menuId3 !== null){
          level0.titles[0].items = [
            {menuId: result.menuId3, menuName:result.menuName3, icon: result.icon3, link: result.link3, sequence: result.sequence3}
          ]
        }
      }
      all.push(level0)
    }else{
      //console.log(level0Empty[0].menuName)
      //console.log(level0Empty[0].titles)
      var level1Empty = level0Empty[0].titles.filter(function(item, index, array){
        return item.menuId === result.menuId2;
      });
      if(level1Empty.length === 0){
        var level1 = {menuId: result.menuId2, menuName:result.menuName2, icon: result.icon2, sequence: result.sequence2, items:[]}
        
        if(result.menuId3 !== null){
          level1.items = [
            {menuId: result.menuId3, menuName:result.menuName3, icon: result.icon3, link: result.link3, sequence: result.sequence3}
          ]
        }
        level0Empty[0].titles.push(level1);
      }else{
        //console.log("level1Empty[0].items")
        //console.log(level1Empty[0].items)
        var level2Empty = level1Empty[0].items.filter(function(item, index, array){
          return item.menuId === result.menuId3;
        });
        if(level2Empty.length === 0){
          var level2 = {menuId: result.menuId3, menuName:result.menuName3, icon: result.icon3, link: result.link3, sequence: result.sequence3}
          level1Empty[0].items.push(level2);
        }
      }
    }
  });
  return all;
}


export const getPageUserList = ({success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_PAGE_USERLIST, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        //console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
      }, 
      failure
    })
  }
}

export const getPageRealList = ({success, failure}) => {
  var token = getToken()
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_PAGE_REALLIST, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        //console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
      }, 
      failure
    })
  }
}

export const addMenu = ({mReqMenu, url, success, failure}) => {
  console.log(mReqMenu)
  console.log(url)
  var token = getToken()
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqMenu, token}), 
      url, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        //console.log(jsonDate)
        success()
      }, 
      failure:(err)=>{
        failure()
      }
    })
  }

  /*
  fetch(URL_MENU + url, 
    fetchBody(body2String(obj))
  )
  .then((response) => {
      //console.log(response);
    return response.json();
  }).then((jsonDate)=>{
    //console.log("jsonDate :")
    fn(true);
  }).catch((err)=>{
    console.log("錯誤 :", err)
    fn(false);
  })
  */
}

export const addPage = ({mReqPage, success, failure}) => {
  var token = getToken()
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPage, token}), 
      url: URL_PAGE_ADD, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success()
      }, 
      failure:(err)=>{
        failure()
      }
    })
  }
  /*
  fetch(URL_PAGE + "add", 
    fetchBody("pageName="+pageName+"&pageDescription="+pageDescription+"&pageLink="+pageLink+"&menuId="+menuId)
  )
  .then((response) => {
      //console.log(response);
    return response.json();
  }).then((jsonDate)=>{
    //console.log("jsonDate :")
    fn(true);
  }).catch((err)=>{
    console.log("錯誤 :", err)
    fn(false);
  })
  */
}